import { deserialize } from 'cerialize'

export class ResponseCatalogWithQuery<T = unknown, M = unknown> {
	@deserialize public current_page?: number
	@deserialize public per_page?: number
	@deserialize public total_entries?: number
	@deserialize public entries: T[]
	@deserialize public meta?: M
	@deserialize public query?: string

	public constructor(data?: any) {
		this.current_page = +data?.current_page || undefined
		this.per_page = +data?.per_page || undefined
		this.total_entries = !Number.isNaN(+data?.total_entries) ? +data?.total_entries : undefined
		this.entries = data?.entries || []
		this.meta = data?.meta || undefined
		this.query = data?.query || null
	}
}
